module.exports = __webpack_public_path__ + "img/marc_d.3056f319.png";